import { Menu } from "@mui/material";
import React, { useCallback, useEffect, useMemo, useState } from "react";

import {
  buildCombinedStaticRanges,
  createCustomStaticRanges,
  findMatchingStaticRange,
} from "../../utils";
import DateRangeComponent from "./dateRange";
import { useDateFilter } from "../../hooks/useFilterContext";
import calenderImage from '../../assets/images/calender.svg';

function SelectDatePicker() {
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);
  const [menuHorizontal, setMenuHorizontal] = useState<"left" | "right">("right");
  const [menuHorizontalOffset, setMenuHorizontalOffset] = useState("16px");
  const [selectedDateLabel, setSelectedDateLabel] = useState("");

  // Use the enhanced date filter hook
  const { filters, formattedDateRange } = useDateFilter();

  const open = Boolean(anchorEl);

  const handleClose = useCallback(() => {
    setAnchorEl(null);
  }, []);

  const handleOpen = useCallback((event: React.MouseEvent<HTMLDivElement>) => {
    const nextAnchor = event.currentTarget;
    const rect = nextAnchor.getBoundingClientRect();
    const leftSpace = rect.left;
    const rightSpace = window.innerWidth - rect.right;

    if (rightSpace >= leftSpace) {
      setMenuHorizontal("left");
      setMenuHorizontalOffset("16px");
    } else {
      setMenuHorizontal("right");
      setMenuHorizontalOffset("16px");
    }

    setAnchorEl(nextAnchor);
  }, []);

  const heading = useMemo(() => {
    return formattedDateRange;
  }, [formattedDateRange]);

  const handleSelectedLabel = useCallback((value: any) => {
    setSelectedDateLabel(value ?? "");
  }, []);

  const customStaticRanges = useMemo(() => {
    return createCustomStaticRanges(filters.startDate, filters.endDate);
  }, [filters.startDate, filters.endDate]);

  const allStaticRanges = useMemo(() => {
    return buildCombinedStaticRanges(customStaticRanges || []);
  }, [customStaticRanges]);

  useEffect(() => {
    if (filters.startDate && filters.endDate) {
      const staticRange = findMatchingStaticRange(
        filters.startDate,
        filters.endDate,
        allStaticRanges
      );
      handleSelectedLabel(staticRange?.label === "Custom" ? "" : staticRange?.label);
    } else {
      handleSelectedLabel("");
    }
  }, [filters.startDate, filters.endDate, allStaticRanges, handleSelectedLabel]);

  return (
    <>
      <div onClick={handleOpen} className={`date-filter-input-container`}>
        <p className="date-filter-input">
          {selectedDateLabel === "" || selectedDateLabel === undefined
            ? heading
            : selectedDateLabel}
        </p>
        <img src={calenderImage} alt="calendar" />
      </div>
      <Menu
        id="user-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        className="date-filter"
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: menuHorizontal,
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: menuHorizontal,
        }}
        PaperProps={{
          sx: {
            marginLeft: menuHorizontal === "left" ? menuHorizontalOffset : 0,
            marginRight: menuHorizontal === "right" ? menuHorizontalOffset : 0,
            width: "fit-content",
            maxWidth: "calc(100vw - 32px)",
            overflow: "auto",
          }
        }}
      >
        <DateRangeComponent
          onClose={handleClose}
          customStaticRanges={customStaticRanges}
        />
      </Menu>
    </>
  );
}
export default SelectDatePicker;
